export default __webpack_public_path__ + "static/ups_w.c0f29b4ef0c8a5c094e209a800833992.svg";